export default function ListViewCardSkeleton(): JSX.Element {
  return (
    <div
      role="status"
      className="my-4 flex h-36 w-full flex-col justify-between gap-1 rounded-lg bg-background shadow-2"
    >
      <div className="flex h-1/2 w-full">
        <div className="bg-shimmer h-20 w-1/3 flex-shrink-0 animate-shimmer bg-[length:200%_100%]" />
        <div className="mx-2 mt-2 flex w-full flex-col items-start justify-between gap-2">
          <div className="bg-shimmer h-4 w-full animate-shimmer rounded-sm bg-[length:200%_100%]" />
          <div className="bg-shimmer h-4 w-2/3 animate-shimmer rounded-sm bg-[length:200%_100%]" />
          <div className="bg-shimmer h-4 w-4/5 animate-shimmer rounded-sm bg-[length:200%_100%]" />
        </div>
      </div>
      <div className="m-2 flex flex-col gap-2">
        <div className="bg-shimmer h-4 w-3/4 animate-shimmer rounded-sm bg-[length:200%_100%]" />
        <div className="bg-shimmer h-4 w-1/2 animate-shimmer rounded-sm bg-[length:200%_100%]" />
      </div>
    </div>
  );
}
